// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsPlanLevelFundingDto
 */
export interface IIsPlanLevelFundingDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsPlanLevelFundingDto
     */
    is_plan_level_funding?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsPlanLevelFundingDto
     */
    is_plan_level_funding_state?: IIsPlanLevelFundingDtoIsPlanLevelFundingStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsPlanLevelFundingDtoIsPlanLevelFundingStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsPlanLevelFundingDto interface.
 */
export function instanceOfIIsPlanLevelFundingDto(value: object): value is IIsPlanLevelFundingDto {
    return true;
}

export function IIsPlanLevelFundingDtoFromJSON(json: any): IIsPlanLevelFundingDto {
    return IIsPlanLevelFundingDtoFromJSONTyped(json, false);
}

export function IIsPlanLevelFundingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsPlanLevelFundingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : json['is_plan_level_funding'],
        'is_plan_level_funding_state': json['is_plan_level_funding_state'] == null ? undefined : json['is_plan_level_funding_state'],
    };
}

export function IIsPlanLevelFundingDtoToJSON(json: any): IIsPlanLevelFundingDto {
    return IIsPlanLevelFundingDtoToJSONTyped(json, false);
}

export function IIsPlanLevelFundingDtoToJSONTyped(value?: IIsPlanLevelFundingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_plan_level_funding': value['is_plan_level_funding'],
        'is_plan_level_funding_state': value['is_plan_level_funding_state'],
    };
}

